
import axios from 'utils/axios';
import {dispatch, store} from 'store';
import {LifeStageProps} from "types/props-obj/LifeStageProps";

import {createSlice} from '@reduxjs/toolkit';

const initialState: LifeStageProps = {
    apiEndPoint: "lead-kanban",
    pageLimit: 5,
    pageNumber: 1,
    isOpen: false,
    list: [],
    item: null,
    error: null,
    alertPopup: false
};

const leadKanban = createSlice({
    name: initialState.apiEndPoint,
    initialState,
    reducers: {
        hasError(state, action) {
            state.error = action.payload.error;
        },
        setPageNumber(state, action) {
            state.pageNumber = action.payload;
        },
        setPageLimit(state, action) {
            state.pageLimit = action.payload;
        },
        // get all Item list
        getList(state, action) {
            state.list.push(action.payload);
            // state.list = state.list.filter((liste) => liste?.id != 0);
        },
        alertPopupToggle(state, action) {
            state.alertPopup = action.payload.alertPopup;
        },
        openToggle(state, action) {

            state.isOpen = action.payload.isOpen;
        },
        // get Item details
        setItem(state, action) {
            state.item = action.payload;
        },

        // GET Items
        setItemsSuccess(state, action) {
            state.list = action.payload;
            // state.current_page=action.payload.current_page;
            // state.last_page=action.payload.last_page;
            // state.total=action.payload.total
        },

        // ADD Item
        addItemSuccess(state, action) {
            state.list = [...state.list,action.payload];
        },

        // EDIT Item
        editItemSuccess(state, action) {
          
          action.payload.forEach((element:any) => {
              var foundIndex = state.list.findIndex(x => x.id === element.id);
              state.list[foundIndex] = element;
            });
            // state.item=action.payload;
        },

        deleteItemSuccess(state, action) {
            state.list = state.list.filter((item) => item.id !== action.payload);
        },

        deleteItemBeforeEdit(state, action) {
            if(0<state.list.length){var lsIndex = state.list?.findIndex((item) =>item.id === action.payload.stage_id);
                state.list[lsIndex]['leads']=state.list[lsIndex]['leads'].filter((item:any) => item.id !== action.payload.lead_id);
            }
      },



        setApiEndPoint(state, action) {
            state.apiEndPoint = action.payload;
        },


    }
});


export default leadKanban.reducer;

function getApiEndPoint(){
    return store.getState().leadKanban.apiEndPoint
}

export const { alertPopupToggle,openToggle,setPageNumber,setPageLimit,setApiEndPoint,deleteItemBeforeEdit ,setItem} = leadKanban.actions;
export function getList(params:any={}) {
    return async () => {
        try {
            const response = await axios.get(getApiEndPoint(),{params:params});
            dispatch(leadKanban.actions.setItemsSuccess(response.data));
        } catch (error) {
            dispatch(leadKanban.actions.hasError(error));
        }
    };
}

export function getItem(id: number | undefined) {
    return async () => {
        try {
            const response = await axios.get([getApiEndPoint(),  id].join('/'));
            dispatch(leadKanban.actions.setItem(response.data));
        } catch (error) {
            dispatch(leadKanban.actions.hasError(error));
        }
    };
}

export function addItem(ls:any) {
    return async () => {
        try {
            const response = await axios.post(getApiEndPoint(), ls);
            dispatch(leadKanban.actions.addItemSuccess(response.data));
        } catch (error) {
            dispatch(leadKanban.actions.hasError(error));
        }
    };
}

export function editItem(id: number ,sourceLId:number| undefined,ls: any) {
    return async () => {
        try {
          
          // dispatch(leadKanban.actions.deleteItemBeforeEdit({lead_id:id,stage_id:sourceLId}));
            const response = await axios.put([getApiEndPoint(),  id].join('/'), ls);
            dispatch(leadKanban.actions.editItemSuccess(response.data));
        } catch (error) {
            dispatch(leadKanban.actions.hasError(error));
        }
    };
}

export function deleteItem(id: number | undefined,sourceLId:number| undefined) {
    return async () => {
        try {
            await axios.delete([getApiEndPoint(),  id].join('/'));
            // dispatch(leadKanban.actions.deleteItemSuccess({lead_id:id,source_id:sourceLId}));
            dispatch(leadKanban.actions.deleteItemBeforeEdit({lead_id:id,stage_id:sourceLId}));
        } catch (error) {
            dispatch(leadKanban.actions.hasError(error));
        }
    };
}